import { render, staticRenderFns } from "./veStuGraduationManage.vue?vue&type=template&id=5a815980&scoped=true"
import script from "./veStuGraduationManage.vue?vue&type=script&lang=js"
export * from "./veStuGraduationManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a815980",
  null
  
)

export default component.exports